<div id="infrastructure">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                    <h4 class="card-title">Cafeteria</h4>
                        <p class="inner-lead">A spacious and well-furnished canteen is available in the campus for the benefit of the students. A contractor run canteen on campus offers lunch, snacks, tea, coffee & cold drinks at reasonable prices on all working days. It also provides them with some moments of relief within the frame work of their day long hectic schedules.</p>
                    </div>
                </div>
            </div>
        </div>